import uniqBy from "lodash/uniqBy";
import take from "lodash/take";
import flatMap from "lodash/flatMap";
import { useContext } from "@nuxtjs/composition-api";
import INSPIRATIONS from "~/components/_refactored/inspirationPage/inspirations.graphql";

export function useFetchRelatedInspirations() {
  const { localePath, $query } = useContext();

  return async (inspiration) => {
    if (!inspiration?.professionTasks?.length) {
      return [];
    }

    const relatedInspirationResponses = await Promise.all([
      ...inspiration.professionTasks.map((professionTask) =>
        $query(INSPIRATIONS, {
          professionTaskSeoName: professionTask.seoName,
          page: 1,
          pageSize: 5,
          excludeIds: [inspiration.id],
        })
      ),
    ]);

    const joinedRelatedInspirations = flatMap(
      relatedInspirationResponses,
      (i) => i?.inspirations?.items || []
    );

    const inspirationsWithUrls = joinedRelatedInspirations.map(
      (inspiration) => ({
        ...inspiration,
        url: localePath({
          name: "inspirationPage",
          params: { inspirationSeoName: inspiration.seoName },
        }),
      })
    );

    const uniqueInspirations = uniqBy(inspirationsWithUrls, "id");
    return take(uniqueInspirations, 5);
  };
}
